import { render } from "./HelpDialogWorkflowEntities.vue?vue&type=template&id=8d376870&scoped=true"
import script from "./HelpDialogWorkflowEntities.vue?vue&type=script&lang=js"
export * from "./HelpDialogWorkflowEntities.vue?vue&type=script&lang=js"

import "./HelpDialogWorkflowEntities.vue?vue&type=style&index=0&id=8d376870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d376870"]])

export default __exports__